import { loginMiddleware } from '@clearscore/redux.session-middleware';

export default [loginMiddleware()];
